import { useState } from 'react';
import { FAQ } from '../../config/site';

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="py-16 md:py-24 bg-cream scroll-mt-[132px]">
      <div className="max-w-2xl mx-auto px-6">
        <h2 className="font-inter text-sm md:text-base font-medium tracking-[0.3em] uppercase text-text-primary text-center mb-12">
          FREQUENTLY ASKED
        </h2>

        <div className="border-t border-text-muted/15">
          {FAQ.map((item, idx) => {
            const isOpen = open === idx;
            return (
              <div key={item.q} className="border-b border-text-muted/15">
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : idx)}
                  className="w-full flex items-center justify-between gap-4 py-5 text-left bg-transparent border-0 cursor-pointer"
                  aria-expanded={isOpen}
                >
                  <span className="font-inter text-xs md:text-sm tracking-[0.1em] uppercase text-text-primary">
                    {item.q}
                  </span>
                  <span className="font-display text-xl text-text-muted shrink-0 leading-none">
                    {isOpen ? '–' : '+'}
                  </span>
                </button>
                {isOpen && (
                  <p className="font-inter text-sm leading-relaxed text-text-muted pb-5">{item.a}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
